import { routeActions } from 'redux-simple-router';
import browserStore from 'store';

import {settings}           from 'app/globals';
import {getCompanyName}     from '../repositories/ProfileRepository';
import * as types           from '../constants/actionTypes';

let preferredLicensePlate;

// ========================================================
//                  PUBLIC
// ========================================================

export {
    setPreferredLicensePlate,
    fetchCompanyName,
    setPreferredLanguage
};

// ========================================================
//                  IMPLEMENTATION
// ========================================================

preferredLicensePlate = (licensePlate) => ({
    type: types.LICENSE_PLATE_SET_PREFERRED,
    payload: {
        licensePlate
    }
});

function setPreferredLicensePlate(licensePlate, redirect) {
    return dispatch => {
        dispatch(preferredLicensePlate(licensePlate));
        if (redirect) {
            dispatch(routeActions.push(redirect));
        }
    };
}

function fetchCompanyName() {
    return {
        types: [types.COMPANY_NAME_FETCH_REQUEST, types.COMPANY_NAME_FETCH_SUCCESS, types.COMPANY_NAME_FETCH_FAILED],
        promise: getCompanyName()
    };

    //return dispatch => {
    //    ProfileRepository.getCompanyName()
    //        .then(response => {
    //            dispatch({
    //                type: types.COMPANY_NAME_FETCH_SUCCESS,
    //                payload: response.name
    //            });
    //        });
    //};
}

//function fetchProfile() {
//    return {
//        types: [types.PROFILE_FETCH_REQUEST,types.PROFILE_FETCH_SUCCESS,types.PROFILE_FETCH_FAILED],
//        promise: ProfileRepository.getProfile()
//    };

    //return dispatch => {
    //    ProfileRepository.getProfile()
    //        .then(response => {
    //            dispatch({
    //                type: types.PROFILE_FETCH_SUCCESS,
    //                payload: response.profile
    //            });
    //        });
    //};
//}

function setPreferredLanguage(locale = settings.defaultLocale) {
    if (settings.supportedLocales.indexOf(locale) === -1) {
        locale = settings.defaultLocale;
    }
    browserStore.set('locale', locale);
    return dispatch => {
        dispatch({
            type: types.PROFILE_SET_LOCALE,
            payload: locale
        });
        //document.location.reload();
    };
}